module.exports = __webpack_public_path__ + "700b4a4c4bbcc45e7521bc73f84cd151.jpg";